import Toaster from './Toaster.vue';
import createToaster from './api.js';
import Positions from './defaults/positions.js';
const Plugin = function (app) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let methods = createToaster(options);
  app.$toast = methods;
  app.config.globalProperties.$toast = methods;
};
Toaster.install = Plugin;
export default Toaster;
export { Toaster, Positions, createToaster };